<template>
  <svg width="28" height="28" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12.8564" r="12" fill="#F9F9F9"/>
<path d="M7.90678 18.0055C7.90678 18.7389 8.52073 19.3389 9.27112 19.3389H14.7285C15.4789 19.3389 16.0928 18.7389 16.0928 18.0055V10.0055H7.90678V18.0055ZM16.775 8.00553H14.3874L13.7052 7.33887H10.2944L9.61221 8.00553H7.22461V9.33887H16.775V8.00553Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
svg {
    cursor: pointer;
    circle, path {
        transition: all 0.2s ease;
    }
    &:hover {
        circle {
            fill: #B8CDD7;
        }
        path {
            fill: #F9F9F9;
        }
    }
}
</style>